module.exports = __webpack_public_path__ + "img/door-open.2aa7e5a1.svg";